<template>
<!-- Create a modal for a user to sync their device -->
  <div class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Sync Your Device!</p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <!-- Sync button -->
          <div class="field">
            <div class="control button-control">
              <a class="button is-medium is-fullwidth"
              href="https://www.fitbit.com/oauth2/authorize?response_type=token&client_id=22CKBV&redirect_uri=https%3A%2F%2Fknosis-beta.firebaseapp.com%2Fhome&scope=activity%20profile%20heartrate&expires_in=2592000&state=confirm"
              placeholder="Sync Device">Sync Device</a>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'deviceSyncModal',
    data() {
      return {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fitness/deviceSyncModal.vue